import React from "react";
import { getLeagueAvatarSrc, LEAGUE_AVATAR_FALLBACK } from "../../utils/leagueAvatar";

function LeagueAvatar({ image, name, className = "", decorative = false }) {
  return (
    <img
      src={getLeagueAvatarSrc(image)}
      alt={decorative ? "" : (name ? `${name} avatar` : "League avatar")}
      aria-hidden={decorative ? "true" : undefined}
      className={className}
      onError={(event) => {
        event.currentTarget.onerror = null;
        event.currentTarget.src = LEAGUE_AVATAR_FALLBACK;
      }}
    />
  );
}

export { LeagueAvatar };
